import { api } from '@/services/api'
import { SET, UPDATE, REPLACE_ARRAY_ITEM, MERGE, MERGE_ARRAY, MERGE_ITEM_ARRAY } from '@/plugins/store/mutationTypes'
import { ServiceRFQs } from '@/services/RFQs'

const state = {
  isLoading: false,
  isCreatingPO: false,
  dataRFQ: {},
  listDataPO: [],
  listRFQ2: []
}
const getters = {
  isVisible (state) {
    return !!Object.keys(state['dataRFQ']).length
  },
  mapListRFQ2 (state) {
    return state['listRFQ2'].reduce((result, item) => {
      result[item.id] = item
      return result
    }, {})
  },
  mapListDataPO (state) {
    return state['listDataPO'].reduce((result, item) => {
      result[item.supplierCompanyID] = item
      return result
    }, {})
  },
  getListIncludeToPO (state) {
    return (supplierCompanyID) => {
      return state['listRFQ2'].filter((item) => {
        return item['supplierCompanyID'] === supplierCompanyID && !!item['_includeInPo']
      })
    }
  },
  fullDataRFQ (state) {
    return { ...state['dataRFQ'], ...state['dataViewRFQ'] }
  }
}
const mutations = {
  SET,
  MERGE,
  REPLACE_ARRAY_ITEM,
  MERGE_ARRAY,
  MERGE_ITEM_ARRAY,
  UPDATE
}
const actions = {
  resetState ({ commit }) {
    return Promise.resolve()
      .then(() => {
        commit('SET', { key: 'dataRFQ', value: {} })
        commit('SET', { key: 'listRFQ2', value: [] })
        commit('SET', { key: 'listDataPO', value: [] })
      })
  },
  resetCurrentForm ({ commit }) {
    return Promise.resolve()
      .then(() => {
        commit('SET', { key: 'listRFQ2', value: [] })
        commit('SET', { key: 'listDataPO', value: [] })
      })
  },
  loadData ({ dispatch, commit }, rfqID) {
    commit('SET', { key: 'isLoading', value: true })
    return Promise.all([
      dispatch('loadRFQ', rfqID)
    ])
      .then(() => {
        commit('SET', { key: 'isLoading', value: false })
      })
      .catch((err) => {
        commit('SET', { key: 'isLoading', value: false })
        throw err
      })
  },
  loadRFQ ({ commit }, rfqID) {
    return api
      .get(`RFQs/Get/${rfqID}`)
      .then(({ data }) => {
        commit('SET', { key: 'dataRFQ', value: data })
      })
  },
  createPO ({ dispatch, state, getters, commit }, formDataPO) {
    let list = getters.getListIncludeToPO(formDataPO.supplierCompanyID)
    commit('SET', { key: 'isLoading', value: true })
    commit('SET', { key: 'isCreatingPO', value: true })
    return Promise.resolve()
      .then(() => {
        return Promise.all(list.map((item) => {
          return dispatch('createRFQ1', { formDataPO, dataRFQ2: item })
        }))
      })
      .then(() => {
        return Promise.all(list.map(item => {
          return dispatch('updateRFQ2', { formDataPO, dataRFQ2: item })
        }))
      })
      .then(() => {
        return Promise.all(list.map(item => {
          return dispatch('createSalesOrder', { formDataPO, dataRFQ2: item })
        }))
      })
      .then(() => {
        return Promise.all(list.map(item => {
          return dispatch('repairExchangeOrderFollowUps', { formDataPO, dataRFQ2: item })
            .then((response) => {
              return dispatch('repairExchangeOrderFollowUpLogs', { dataExchange: response.data })
            })
        }))
      })
      .then(() => {
        return dispatch('updateRFQ', { formDataPO })
      })
      .then(() => {
        return dispatch('loadRFQ', state['dataRFQ'].id)
      })
      .then(() => {
        return dispatch('resetCurrentForm')
      })
      .then(() => {
        commit('SET', { key: 'isLoading', value: false })
        commit('SET', { key: 'isCreatingPO', value: false })
      })
      .catch((err) => {
        commit('SET', { key: 'isLoading', value: false })
        commit('SET', { key: 'isCreatingPO', value: false })
        throw err
      })
  },
  createRFQ1 ({ dispatch, state }, { formDataPO, dataRFQ2 }) {
    let _data = {
      rfqid: dataRFQ2.rfqid,
      qty: dataRFQ2.qty,
      partID: dataRFQ2.partID
    }
    return api
      .post(`RFQ1s/Create`, _data)
  },
  updateRFQ2 (context, { formDataPO, dataRFQ2 }) {
    let data = {
      rfqid: dataRFQ2.rfqid,
      chosen: true
    }
    return api
      .patch(`RFQ2s/Patch/${dataRFQ2.id}`, data)
  },
  createSalesOrder (context, { formDataPO, dataRFQ2 }) {
    let data = {
      rfqid: dataRFQ2.rfqid,
      shipToCompanyID: formDataPO.shipToCompanyID,
      shipToCompanyDetailID: formDataPO.shipToCompanyDetailID,
      shipToCompanyContactID: formDataPO.shipToContactID,
      supplierCompanyID: dataRFQ2.supplierCompanyID,
      supplierCompanyContactID: dataRFQ2.supplierContactID,
      vatID: formDataPO.vatID,
      shipViaForwarderID: formDataPO.shipViaForwarderID,
      priorityID: formDataPO.priorityID,
      po: formDataPO.po,
      baxpo: formDataPO.baxpo
    }
    return api
      .post(`SalesOrders/Create`, data)
  },
  repairExchangeOrderFollowUps ({ rootState, rootGetters }, { formDataPO, dataRFQ2 }) {
    const { employeeID } = rootGetters.get('currentUser')
    const data = {
      partID: dataRFQ2.partID,
      partSN: dataRFQ2.partSN,
      rfqid: dataRFQ2.rfqid,
      baxpo: formDataPO.baxpo,
      rfQ2ID: dataRFQ2.id,
      orderPhaseID: 29,
      phaseDate: new Date(),
      phasePersonInChargeEmployeeID: employeeID
    }
    return api
      .post(`RepairExchangeOrderFollowUps/Create`, data)
  },
  repairExchangeOrderFollowUpLogs ({ rootState, rootGetters }, { dataExchange }) {
    const { employeeID } = rootGetters.get('currentUser')
    const data = {
      repairExchangeOrderFollowUpID: dataExchange.id,
      employeeID,
      entryDate: new Date(),
      description: 'new PO',
      isEmployeeEntry: false,
      isRead: false
    }
    return api
      .post(`RepairExchangeOrderFollowUpLogs/Create`, data)
  },
  updateRFQ ({ state }, { formDataPO }) {
    const data = {
      id: state['dataRFQ'].id,
      po: formDataPO.po,
      poDate: formDataPO.poDate,
      requestedDate: formDataPO.requestedDate,
      orderRatingScoreID: formDataPO.orderRatingScoreID,
      paymentTermID: formDataPO.paymentTermID,
      shipToCompanyID: formDataPO.shipToCompanyID,
      shipToCompanyDetailID: formDataPO.shipToCompanyDetailID,
      shipToContactID: formDataPO.shipToContactID,
      customerForwarderID: formDataPO.customerForwarderID
    }
    return ServiceRFQs.createPO(data)
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
